import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../reducers/index';
import * as CmsActions from '../../actions/cms.actions';
import {CmsBlock} from '../../models/cms-blocks';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-cms-page',
    templateUrl: './cms-page.component.html',
    styleUrls: ['cms-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsPageComponent implements OnInit {

    cmsBlocks$: Observable<CmsBlock[]>
    isPending$: Observable<boolean>;

    constructor(private store: Store<fromShared.State>, private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.store.dispatch(CmsActions.loadCmsBlocks());
        this.cmsBlocks$ = this.store.pipe(select(fromShared.getLandingPageBlocks()));
    }
}
